import React from 'react';
import { Link } from '@gravity-ui/uikit';
import { getIsAdmin } from 'client/utils';
import { routes } from 'client/lib/routes';

export const NdaLink = () => {
    if (!getIsAdmin()) return null;

    return (
        <>
            <Link href={routes.documentation.nda} target="_blank">
                NDA
            </Link>
            <span>{` `}</span>
        </>
    );
};
